const updateTabProjections = {};

updateTabProjections.newDocumentWasAddedToCurrentPolicyUpdate = (state) => {

    if(
        (
            (
                !state.updateTab.updatePolicy
                || !state.updateTab.updatePolicy.id
            )
            || (
                !state.updateTab.updatePolicy.attachment
                || (
                    state.updateTab.updatePolicy.attachment
                    && state.updateTab.updatePolicy.attachment.id
                )
            )
        )
        && state.updateTab.attachments
        && !state.updateTab.attachments.id
        && state.updateTab.attachments.name
    ){
        return true;
    }

    return false;
};

export default updateTabProjections;